import { useState, useEffect } from 'react';
import { makeRequest } from '../utils';

export default function useMetadata(requestURL) {
  const [metadata, setMetadata] = useState();
  const [requestMetadata, setRequestMetadata] = useState(true);

  useEffect(() => {
    if (!requestURL.includes('undefined') && requestMetadata === true) {
      makeRequest(requestURL)
        .then((data) => {
          setMetadata(data);
          setRequestMetadata(false);
        })
        .catch((error) => {
          console.error(`Error fetching API data from ${requestURL}: ` + error);
        });
    }
  }, [requestURL, requestMetadata, setRequestMetadata]);

  const handleRequestMetadata = () => {
    setRequestMetadata(true);
  };

  return [metadata, handleRequestMetadata];
}
